import React, { Suspense } from "react";
import type { FixMessage, ParseResult } from "../../domain";
import type { ViewMode } from "../../domain";
import type { ColumnSpec } from "../settings/FixSettings";
import type { DataDictionary } from "../../utils/data-dictionary";
import type {
  GridState,
  GridStateMap,
  TimelineUrlState,
} from "../../utils/memory-schema";
import type { GridId } from "../grid/gridIds";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

const FixParseResults = React.lazy(() => import("./FixParseResults"));

export const LazyFixParseResults = ({
  fixMessages,
  columns,
  setColumns,
  dataDictionary,
  setDataDictionary,
  splitPaneLeftPct,
  setSplitPaneLeftPct,
  viewMode,
  setViewMode,
  selectedRowIndices,
  setSelectedRowIndices,
  gridStates,
  setGridState,
  excludeDateFromMessageTime,
  setExcludeDateFromMessageTime,
  timelineState,
  setTimelineState,
  codeState,
  setCodeState,
}: {
  fixMessages: ParseResult<FixMessage>[];
  columns: ColumnSpec[];
  setColumns: React.Dispatch<React.SetStateAction<ColumnSpec[]>>;
  dataDictionary: DataDictionary;
  setDataDictionary: React.Dispatch<React.SetStateAction<DataDictionary>>;
  splitPaneLeftPct: number | undefined;
  setSplitPaneLeftPct: (v: number | undefined) => void;
  viewMode: ViewMode;
  setViewMode: React.Dispatch<React.SetStateAction<ViewMode>>;
  selectedRowIndices: number[];
  setSelectedRowIndices: (v: number[]) => void;
  gridStates: GridStateMap;
  setGridState: (id: GridId, state: GridState | undefined) => void;
  excludeDateFromMessageTime: boolean;
  setExcludeDateFromMessageTime: (v: boolean) => void;
  timelineState: TimelineUrlState | undefined;
  setTimelineState: (v: TimelineUrlState | undefined) => void;
  codeState: string | undefined;
  setCodeState: (v: string | undefined) => void;
}) => {
  return (
    <Suspense
      fallback={
        <Box sx={{ minHeight: "calc(100vh - 250px)", width: "100%" }}>
          <LinearProgress />
        </Box>
      }
    >
      <FixParseResults
        codeState={codeState}
        columns={columns}
        dataDictionary={dataDictionary}
        excludeDateFromMessageTime={excludeDateFromMessageTime}
        fixMessages={fixMessages}
        gridStates={gridStates}
        selectedRowIndices={selectedRowIndices}
        setCodeState={setCodeState}
        setColumns={setColumns}
        setDataDictionary={setDataDictionary}
        setExcludeDateFromMessageTime={setExcludeDateFromMessageTime}
        setGridState={setGridState}
        setSelectedRowIndices={setSelectedRowIndices}
        setSplitPaneLeftPct={setSplitPaneLeftPct}
        setTimelineState={setTimelineState}
        setViewMode={setViewMode}
        splitPaneLeftPct={splitPaneLeftPct}
        timelineState={timelineState}
        viewMode={viewMode}
      />
    </Suspense>
  );
};
